import { render, staticRenderFns } from "./Build.vue?vue&type=template&id=37705b40&scoped=true"
import script from "./Build.vue?vue&type=script&lang=js"
export * from "./Build.vue?vue&type=script&lang=js"
import style0 from "./Build.vue?vue&type=style&index=0&id=37705b40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37705b40",
  null
  
)

export default component.exports